module.exports = {
  "country": "TR",
  "artist": "Sertab Erener",
  "song": "Everyway That I Can",
  "year": "2003",
  "place": "1",
  "spotify": "5Hi2aJQzS0U7u1wwo8WIFp"
};